"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _compact = _interopRequireDefault(require("lodash/compact"));
var _join = _interopRequireDefault(require("lodash/join"));
var _size = _interopRequireDefault(require("lodash/size"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getConcentrations = function getConcentrations(concentrations) {
  var enabledConcentrations = (0, _compact.default)(concentrations);
  var title = (0, _size.default)(enabledConcentrations) === 1 ? 'Concentration' : 'Concentrations';
  var enabledConcentrationsText = " (".concat(title, ": ").concat((0, _join.default)(enabledConcentrations, ', '), ")");
  return (0, _size.default)(enabledConcentrations) > 0 ? enabledConcentrationsText : '';
};
var _default = getConcentrations;
exports.default = _default;